<template>
  <home-floating-window
    :title="$t('BulkTechnicalPoint')"
    @close="closeBulkTP"
    @changePosition="$emit('changeBulkTPWindowPosition', $event)"
    :pos-x="position.x"
    :pos-y="position.y"
    :draggable="!loading && !dragIsDisabled"
  >
    <template v-slot:iconWindows>
      <BulkTPSVG class="floating-container-svg" />
    </template>

    <template v-slot:objectDivWindows>
      <div class="floating-tool-content">
        <div class="bulk-tp-objects-div">
          <bulk-t-p-creation-type-buttons
            :selection-type="'line'"
            :creatable="true"
            @setType="setBulkTPType"
          />

          <HighlightedBox
            :bad-object="badObject"
            :is-visible="showInstruction"
            :message="currentInstruction"
          />

          <bulk-t-p-creation-options
            :too-many-points-drawn="tooManyPointsDrawn"
            @update-distance="adjustParameters($event.distance, $event.number)"
            @update-number="adjustParameters($event.distance, $event.number)"
            @toggle-drag="dragIsDisabled = $event"
            :count="count"
          />

          <v-checkbox
            v-model="createPathway"
            :label="$tc('pathway_store')"
            color="var(--primary-highlight)"
            style="margin-top: 30px"
          />
        </div>
      </div>

      <home-window-button
        :label="bulkTPLabelButton"
        :disabled="bulkTPButtonDisabled"
        @buttonClick="createBulkTP"
      />

      <loading-spinner
        :active.sync="loading"
        :is-full-page="true"
        color="accent"
      />
    </template>
  </home-floating-window>
</template>

<script>
import { bus } from "@/main";
import { mixin as clickaway } from "vue-clickaway";
import HomeFloatingWindow from "../HomeFloatingWindow";
import BulkTPSVG from "@/assets/bulk_tp_svgs/bulk_tp.svg";
import BulkTPCreationTypeButtons from "./BulkTPCreationTypeButtons";
import HighlightedBox from "@/components/_Molecules/HighlightedBox";
import LoadingSpinner from "vue-loading-overlay";
import HomeWindowButton from "../../HomeWindowButton";
import BulkTPCreationOptions from "./BulkTPCreationOptions.vue";

export default {
  name: "BulkTPWindow",

  components: {
    HomeFloatingWindow,
    BulkTPSVG,
    BulkTPCreationTypeButtons,
    HighlightedBox,
    LoadingSpinner,
    HomeWindowButton,
    BulkTPCreationOptions
  },

  mixins: [clickaway],

  props: {
    bulkTP: {
      type: Object
    },

    position: Object,

    tooManyPointsDrawn: {
      type: Boolean,
      required: true
    },

    bulkFeature: {
      type: Boolean
    },
    count:{
      type:Number
    }
  },

  data() {
    return {
      badObject: false,
      loading: false,
      distanceBetweenTPs: null,
      numberOfTPs: null,
      createPathway: true,
      dragIsDisabled: false
    };
  },

  watch:{
    /**
     * Wacthes for changes in the createPathway variable and adjusts the bulk parameters
     */
    createPathway() {
      this.adjustParameters();
    },
  },

  computed: {
    /**
     * Indicates if the instruction is shown or not
     */
    showInstruction() {
      return this.currentInstruction !== "";
    },

    /**
     * Returns the instruction for the creation
     */
    currentInstruction() {
      return this.$t("BulkTPInstruction");
    },

    /**
     * Returns the label of the form button
     */
    bulkTPLabelButton() {
      return this.$t("Create");
    },

    /**
     * Indicates if the button is disabled or not
     */
    bulkTPButtonDisabled() {
      return !(this.numberOfTPs || this.distanceBetweenTPs) || (this.distanceBetweenTPs && this.distanceBetweenTPs < 1) || !this.bulkFeature;
    },
  },

  /**
   * Listens for events to close the window
   */
  mounted() {
    bus.$on("escape-bulk-tp-window", () => this.closeBulkTP());
    bus.$on("deactivate-bulk_tp_creation", () => this.closeBulkTP());
  },

  /**
   * Stops listening for the events
   */
  destroyed() {
    bus.$off("escape-bulk-tp-window");
    bus.$off("deactivate-bulk_tp_creation");
  },

  methods: {
    /**
     * Closes the window
     */
    closeBulkTP() {
      this.$emit("close");
    },

    /**
     * Sets the type of the bulk creation
     * @param {String} typeOfSelection - the type of bulk creation
     */
    setBulkTPType(typeOfSelection) {
      this.bulkTP.type = typeOfSelection;
      this.resetBulkTP(true);
    },

    /**
     * Emits an event to reset the creation
     * @param {Boolean} unbindEvent - indicates if the creation is to be reset
     */
    resetBulkTP(unbindEvent) {
      this.$emit("resetBulkTP", unbindEvent);
    },

    /**
     * Adjusts the parameters of the bulk tp creation
     */
    adjustParameters(distance = this.distanceBetweenTPs, number = this.numberOfTPs) {
      this.distanceBetweenTPs = distance;
      this.numberOfTPs = number;
      this.$emit('adjustParameters', {
        distanceBetweenTPs: distance,
        numberOfTPs: number,
        createPathway: this.createPathway
      })
    },

    /**
     * Emits an event to open the dialog to select the type of tech point to be created
     */
    createBulkTP() {
      this.$emit("openTechPointSelectionDialog");
    }
  }
};
</script>

<style scoped>
input:invalid,
textarea:invalid {
  border: 1px solid var(--red);
}

.bulk-tp-objects-div {
  padding: 5px 10px;
  min-height: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/BulkTP/BulkTPWindow.vue